import { AltiusRes } from "store/types";
import { AsyncActions, AsyncActionsParams } from "../base";

interface IRootDealActions {}

export class RootDealActions extends AsyncActions implements IRootDealActions {
  public constructor(params: AsyncActionsParams) {
    super(params);
  }

  protected isSharedDeal = async (id: number): Promise<boolean> => {
    const {
      data: {
        data: { is_deal_from_another_account }
      }
    } = await this.api.get<AltiusRes<{ is_deal_from_another_account: boolean }>>({
      url: `/api/v0.0.3/another-account-deal/${id}`
    });

    return is_deal_from_another_account;
  };
}
